export default __webpack_public_path__ + "img/7d0f22541ce4f1ba6c2cd08dc16a2be4.svg";